const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d+)?Z?)?$/;

// Términos de negocio que indican un campo de dinero. Conservador a propósito: si no
// matchea, no se formatea (mejor no adornar que adornar mal un campo que no es dinero).
// Multi-divisa (MXN/USD según "moneda"/"tipoCambio") — se usa "$" genérico, no se asume
// una sola divisa como en otros proyectos.
const MONEY_KEYWORDS = [
  "importe", "monto", "saldo", "precio", "valor", "deposito", "total",
  "comision", "subtotal", "iva", "renta", "pago", "cargo", "abono", "utilizado",
];
const EXCLUDE_KEYWORDS = ["porcentaje", "cantidad", "dias", "numero", "tasa", "participacion"];

function pareceCampoDinero(columnName) {
  if (!columnName) return false;
  const c = columnName.toLowerCase();
  if (EXCLUDE_KEYWORDS.some((k) => c.includes(k))) return false;
  return MONEY_KEYWORDS.some((k) => c.includes(k));
}

/** Formatea valores del asistente para mostrar: fechas ISO -> dd/mm/yyyy, dinero -> $ con separadores. */
export function formatCellValue(value, columnName) {
  if (typeof value === "string" && ISO_DATE_RE.test(value)) {
    const [y, m, d] = value.slice(0, 10).split("-");
    return `${d}/${m}/${y}`;
  }
  if (typeof value === "number" && pareceCampoDinero(columnName)) {
    return `$${value.toLocaleString("es-MX", { maximumFractionDigits: 2 })}`;
  }
  return value == null ? "" : String(value);
}

/** Aplica formatCellValue a todas las celdas de un array de filas (para exportar). */
export function formatRowsForExport(rows) {
  return rows.map((row) => {
    const out = {};
    Object.keys(row).forEach((k) => { out[k] = formatCellValue(row[k], k); });
    return out;
  });
}
